// src/hooks/useUpdateUserProfile.ts
import { useState } from 'react';
import { ChangePassword } from '../interfaces';
import config from '../config';
import { useSession } from '../contexts/SessionContext';

const useUpdatePassword = () => {
  const [error, setError] = useState<string | null>(null);
  const { sessionState } = useSession();

  const updatePassword = async (updatePasswordData: ChangePassword) => {
    const token = sessionState.account?.token;
    if (!token) {
      setError('Login or token is missing');
      return { success: false, message: 'Login or token is missing' };
    }

    try {
      const response = await fetch(`${config.centralApiBaseUrl}/password/change`, {
        method: 'PUT',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(updatePasswordData),
      });

      if (!response.ok) {
        if (response.status === 429) {
          throw new Error('tooManyRequests');
        }
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to update user profile');
      }

      return { success: true, message: null };
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred';
      return { success: false, message: errorMessage };
    }
  };

  return { updatePassword, error };
};

export default useUpdatePassword;
